import React, { useEffect } from 'react';
import { Button } from '@appkit4/react-components/button';
import { useAuth } from 'react-oidc-context';
import './LandingPage.scss';
import { useLocation } from 'react-router-dom';
import { AppRoutes, LoginRedirectStorageKey } from '../../Constants';
import { ReactComponent as PwCLogo } from '../../assets/icons/New Brand Icons/PwC Logo.svg';

const LandingPage = () => {
    const auth = useAuth();
    const location = useLocation();

    useEffect(() => {
        document.body.classList.add('landing');
        return () => {
            document.body.classList.remove('landing');
        };
    }, []);

    useEffect(() => {
        if (!auth.isLoading && auth.isAuthenticated) {
            const returnRoute =
                window.sessionStorage.getItem(LoginRedirectStorageKey) ||
                AppRoutes.HomePage;

            window.location.replace(returnRoute);
        }
    }, [auth.isLoading, auth.isAuthenticated]);

    const handleLogIn = () => {
        const returnRoute = location.state?.returnRoute;

        if (returnRoute) {
            window.sessionStorage.setItem(LoginRedirectStorageKey, returnRoute);
        }

        if (auth.isAuthenticated) {
            window.location.href = AppRoutes.HomePage;
            return;
        }

        auth.signinRedirect();
    };

    return (
        <div className="landing-page">
            <PwCLogo className="landing-logo" />
            <div className="landing-content">
                <p className="landing-welcome">Welcome to</p>
                <h1 className="landing-title">Fixed asset sorter</h1>
                <Button
                    onClick={handleLogIn}
                    className="landing-sso-btn"
                    kind="primary"
                >
                    SSO Login
                </Button>
            </div>
            <footer className="landing-footer">
                <p>
                    ©{new Date().getFullYear()} PwC. All rights reserved. PwC
                    refers to the PwC network and/or one or more of its member
                    firms, each of which is a separate legal entity.
                </p>
                <p>
                    Please see{' '}
                    <a
                        href="https://www.pwc.com/structure"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        pwc.com/structure
                    </a>{' '}
                    for further details.
                </p>
            </footer>
        </div>
    );
};

export default LandingPage;
